import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import ApprovalOutlinedIcon from "@mui/icons-material/ApprovalOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";


import TrackChangesOutlinedIcon from "@mui/icons-material/TrackChangesOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, LineTrendChart } from "../../components/charts";

const requisitionTrend = [32, 36, 41, 45, 48, 54, 59, 57, 63, 66, 69, 72];

const approvalBacklog = [
  { label: "Direction Générale", value: 38, color: "#163A5F" },
  { label: "Opérations", value: 74, color: "#116B43" },
  { label: "DSI", value: 52, color: "#2471A3" },
  { label: "Bingo", value: 61, color: "#D68910" },
];

const commitmentCoverage = [
  { label: "Hydrocarbures", value: 71, color: "#116B43" },
  { label: "Maintenance", value: 54, color: "#163A5F" },
  { label: "SI / Digital", value: 43, color: "#2471A3" },
  { label: "Sécurité sites", value: 62, color: "#D68910" },
];

const agingView = [
  { label: "0–7 jours", value: 78, color: "#116B43" },
  { label: "8–15 jours", value: 49, color: "#2471A3" },
  { label: "16–30 jours", value: 33, color: "#D68910" },
  { label: "30+ jours", value: 21, color: "#C0392B" },
];

const reqAlerts = [
  {
    title: "Backlog d’approbation sur les demandes Opérations",
    description: "Le volume de demandes en attente augmente plus vite que le rythme de validation.",
    tone: "warning" as const,
  },
  {
    title: "Engagements en retard sur plusieurs requêtes validées",
    description: "Certaines demandes approuvées n’ont pas encore été converties en engagement ou commande.",
    tone: "danger" as const,
  },
  {
    title: "Bonne conversion sur les demandes SI prioritaires",
    description: "Les requêtes critiques du domaine SI progressent correctement jusqu’au stade d’engagement.",
    tone: "success" as const,
  },
];

const requesterPressure = [
  { label: "Opérations", value: 77, color: "#116B43" },
  { label: "Bingo", value: 63, color: "#D68910" },
  { label: "DSI", value: 48, color: "#2471A3" },
  { label: "Direction Générale", value: 31, color: "#163A5F" },
];








export default class RequisitionDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {requestsByState={},requestsByType={},monthlyTrend={},topItems={},pendingAlerts={}} = sections;

  const iconMap: any = {
    info: <TrackChangesOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
    success: <CheckCircleOutlineOutlinedIcon />,
    danger: <ErrorOutlineOutlinedIcon />,
    default: <ErrorOutlineOutlinedIcon />,
  }

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Réquisitions & Engagements"
        subtitle="Vue consolidée de la demande, des validations, des engagements et des pressions budgétaires futures déjà en cours."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={requestsByState.title || ""}
          subtitle={requestsByState.subtitle || ""}
        >
          <DonutChart data={(requestsByState.data || [])} />
        </SectionCard>

        <SectionCard
          title={requestsByType.title || ""}
          subtitle={requestsByType.subtitle || ""}
        >
          <BarChart data={requestsByType.data || []} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "1fr" }}>
        <SectionCard
          title={monthlyTrend.title || ""}
          subtitle={monthlyTrend.subtitle || ""}
        >
          <LineTrendChart data={(monthlyTrend.data || [])} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={topItems.title || ""}
          subtitle={topItems.subtitle || ""}
        >
          <BarChart horizontal data={(topItems.data || [])} />
        </SectionCard>

        <SectionCard
          title={pendingAlerts.title || ""}
          subtitle={pendingAlerts.subtitle || ""}
        >
          <AlertList items={pendingAlerts.data || []} />
        </SectionCard>
      </Box>


{/* 
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Réquisitions"
          value="186"
          subtitle="Demandes enregistrées"
          delta="+12%"
          tone="info"
          icon={<ReceiptLongOutlinedIcon />}
        />
        <SummaryCard
          title="Validées"
          value="129"
          subtitle="Approuvées"
          delta="69,4%"
          tone="success"
          icon={<ApprovalOutlinedIcon />}
        />
        <SummaryCard
          title="Engagées"
          value="84"
          subtitle="Converties en engagement"
          delta="65,1%"
          tone="default"
          icon={<ShoppingCartCheckoutOutlinedIcon />}
        />
        <SummaryCard
          title="Montant engagé"
          value="14,2 Md"
          subtitle="Demandes converties"
          delta="20,3%"
          tone="success"
          icon={<PaidOutlinedIcon />}
        />
        <SummaryCard
          title="En attente"
          value="57"
          subtitle="Backlog courant"
          delta="18 urgentes"
          tone="warning"
          icon={<PendingActionsOutlinedIcon />}
        />
        <SummaryCard
          title="Cycle moyen"
          value="11 j"
          subtitle="Validation → engagement"
          delta="+2 j"
          tone="danger"
          icon={<AccessTimeOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance des réquisitions"
            subtitle="Évolution du flux de demandes sur la période sélectionnée."
            action={<StatusBadge label="Demand pipeline" tone="info" />}
          >
            <MockTrendChart points={requisitionTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes workflow"
            subtitle="Points de tension sur les validations et les engagements."
          >
            <AlertList items={reqAlerts} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Backlog d’approbation"
            subtitle="Demandes en attente par centre ou unité."
          >
            <MockBarChart data={approvalBacklog} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Couverture engagement"
            subtitle="Part des requêtes validées converties en engagement."
          >
            <MockBarChart data={commitmentCoverage} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Vieillissement des demandes"
            subtitle="Lecture simple de l’ancienneté du pipeline."
            action={<StatusBadge label="Aging" tone="warning" />}
          >
            <MockBarChart data={agingView} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Pression par demandeur"
            subtitle="Centres de coûts générant la plus forte demande."
          >
            <MockBarChart data={requesterPressure} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture management"
            subtitle="Messages clés sur la dynamique de demande et l’engagement budgétaire."
          >
            <Stack spacing={1.25}>
              {[
                ["Le pipeline de demande anticipe la pression future", "Les réquisitions validées mais non encore engagées représentent déjà une pression budgétaire réelle à court terme."],
                ["Les opérations dominent la demande", "Les unités d’exploitation restent le principal moteur du flux de réquisitions et nécessitent un pilotage rapproché."],
                ["Le délai de conversion doit être surveillé", "Le temps moyen entre validation et engagement influence directement la fluidité d’exécution et la prévisibilité budgétaire."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
